import { createEvent, createStore } from 'effector';

export const $isSidebarCollapsed = createStore<boolean>(true);
export const setIsSidebarCollapsed = createEvent<boolean>();
$isSidebarCollapsed.on(setIsSidebarCollapsed, (_, payload) => payload);
